import type { Collection } from '@/scopes/search/search/infrastructure/api/types'

import { CollectionCard } from '@/scopes/common/components/CollectionCard'

interface CollectionBannerProps {
  collection: Collection
  description: string
  image: string
  title: string
  usps: string[]
}

export function CollectionBanner({ collection, description, image, title, usps }: CollectionBannerProps) {
  return (
    <CollectionCard
      imageUrl={image}
      collectionId={collection.id}
      name={collection.name}
      title={title}
      description={description}
      usps={usps}
    />
  )
}

CollectionBanner.displayName = 'CollectionBanner'
